<template>
    <v-dialog
        :value="value"
        max-width="1000px"
        scrollable
        @input="$emit('input', $event)"
        @keydown.enter.prevent="save"
        @keydown.esc.prevent="cancel"
    >
        <v-card :loading="loading" :disabled="disabled">
            <v-card-title class="text-h5 grey lighten-2">
                <span class="text-h5">{{ $t('edit_eo') }}</span>
            </v-card-title>
            <v-card-text style="max-height: var(--usable-dialog-height)">
                <light-toolbar dense>
                    <v-toolbar-title>
                        <LegalTypeIcon :address-record="eventOrganizer" class="mr-1" />
                        <span v-if="eventOrganizer.legal_type === 'person'">{{ $t('person') }}: </span>
                        <span v-else-if="eventOrganizer.legal_type === 'organization'">{{ $t('organization') }}: </span>
                        <span v-else>({{ $t('no_type') }}): </span>
                        <strong>{{
                            eventOrganizer.title || `${eventOrganizer.first_name ?? ''} ${eventOrganizer.surname ?? ''}`
                        }}</strong>
                    </v-toolbar-title>

                    <v-spacer />

                    <KpIcon :icon-cls="eventOrganizer.status_icon" :color="eventOrganizer.status_icon_color" left />
                    <span class="grey--text">{{ eventOrganizer.humanReadableStatus }}</span>
                </light-toolbar>
                <KpAlert v-if="!writable" class="mt-5" type="warning">
                    Du kannst diesen Veranstalter nicht bearbeiten: Du hast keinen Schreib-Zugriff auf diesen Datensatz.
                </KpAlert>
                <EditForm
                    ref="editForm"
                    :event-organizer="eventOrganizer"
                    :writable="writable"
                    @input="isValid = $event"
                    @loading="loading = $event"
                    @event-organizer-changed="$emit('event-organizer-changed', $event)"
                    @address-changed="$emit('address-changed', $event)"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <PlainBtn
                    text
                    :to="{ name: 'address-edit', params: { id: eventOrganizer.address_id } }"
                    target="_blank"
                    >{{ $t('open_in_new_tab') }}</PlainBtn
                >
                <PlainBtn text @click="cancel">{{ $t('cancel') }}</PlainBtn>
                <ActionBtn :loading="saving" :disabled="!isValid" @click="save">{{ $t('save') }}</ActionBtn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EditForm from '@/components/event_organizer/EditForm.vue';
import { EventOrganizer } from '@/models/EventOrganizer';
import { errToStr } from '@/helpers/tools';
import { mapActions } from 'vuex';
import LegalTypeIcon from '../address/LegalTypeIcon.vue';

export default {
    name: 'EventOrganizerEditDialog',
    components: {
        EditForm,
        LegalTypeIcon,
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        eventOrganizer: {
            type: EventOrganizer,
            required: true,
        },
        writable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            saving: false,
            loading: false,
            isValid: false,
        };
    },

    computed: {
        disabled() {
            return this.loading || this.saving;
        },
    },

    methods: {
        ...mapActions(['runAsync']),

        async save() {
            this.saving = true;
            try {
                await this.runAsync(async () => await this.$refs.editForm.save());
                this.$emit('input', false);
            } catch (e) {
                this.$toast({ message: errToStr(e), color: 'error' });
            } finally {
                this.saving = false;
            }
        },

        cancel() {
            this.$emit('input', false);
        },
    },
};
</script>

<style lang="scss" scoped></style>
